import React from "react";
import PropTypes from "prop-types";

import { formatDeliveryEstimate } from "utils/deliveryEstimate";
import { formatValue } from "../format";
import {
  SellerTitle,
  ProductWrapper,
  Thumb,
  ProductInfo,
  ProductName,
  ProductChar,
  ProductValue,
  InfoRow,
} from "../styles";

function brandLabelOf(product) {
  const b = product?.brand;
  if (!b) return "";
  if (typeof b === "string") return b;
  return b.label || b.name || "";
}

function getCharacteristic(product) {
  if (product?.short_description) return product.short_description;
  const first = product?.characteristics?.[0];
  if (first) return [first.title, first.value].filter(Boolean).join(": ");
  return "";
}

function priceMoney(product) {
  return parseFloat(product?.price?.BRL?.offer || product?.price?.BRL?.price || 0);
}

function pricePoints(product) {
  return parseInt(
    product?.price?.points?.offer || product?.price?.points?.points || 0,
    10,
  );
}

export default function SellerProductGroup({
  sellerName,
  products = [],
  shippingByBrand = {},
  displayMode,
}) {
  const brandUuid = products?.[0]?.brand_uuid;
  const brandShipping = (brandUuid && shippingByBrand?.[brandUuid]) || {};
  const shippingMoney = parseFloat(brandShipping?.shipping_amount || 0);
  const shippingPoint = parseFloat(brandShipping?.shipping_point || 0);
  const deliveryDateLabel = formatDeliveryEstimate({
    estimatedDeliveryDate: brandShipping?.shipping_delivery_date,
    estimatedBusinessDays: brandShipping?.shipping_deadline,
    variant: "summary",
  });

  const productsMoney = products.reduce(
    (acc, p) => acc + priceMoney(p) * (p.quantity || 1),
    0,
  );
  const productsPoints = products.reduce(
    (acc, p) => acc + pricePoints(p) * (p.quantity || 1),
    0,
  );

  const subtotalMoney = productsMoney + shippingMoney;
  const subtotalPoints = productsPoints + shippingPoint;

  return (
    <div>
      <SellerTitle>Produto vendido por {sellerName}</SellerTitle>

      {products.map((product, idx) => {
        const brandLabel = brandLabelOf(product);
        return (
          <ProductWrapper key={product.sku || product.id || idx}>
            <Thumb src={product.image} alt={product.label} />
            <ProductInfo>
              <ProductName>{brandLabel || product.label}</ProductName>
              <ProductChar>{getCharacteristic(product)}</ProductChar>
              <ProductValue>
                {formatValue(
                  displayMode,
                  priceMoney(product) * (product.quantity || 1),
                  pricePoints(product) * (product.quantity || 1),
                )}
              </ProductValue>
            </ProductInfo>
          </ProductWrapper>
        );
      })}

      <InfoRow>
        <span>Frete</span>
        <span className="value">
          {formatValue(displayMode, shippingMoney, shippingPoint)}
        </span>
      </InfoRow>
      <InfoRow>
        <span>Subtotal</span>
        <span className="value">
          {formatValue(displayMode, subtotalMoney, subtotalPoints)}
        </span>
      </InfoRow>
      <InfoRow>
        <span>Chega até</span>
        <span className="value">{deliveryDateLabel}</span>
      </InfoRow>
    </div>
  );
}

SellerProductGroup.propTypes = {
  sellerName: PropTypes.string,
  products: PropTypes.array,
  shippingByBrand: PropTypes.object,
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
};
